import React, { useEffect } from "react";
import { Outlet, Navigate, useNavigate } from "react-router-dom";
import Sidebar from "../pages/profile/student/Sidebar";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import { updateDashboardState, useSelectAccess } from "../store/stateFunctions";
import { server } from "../common";

const StudentContainer = () => {
  document.title = "Student Profile";
  const student = useSelectAccess("Student");

  // const navigate = useNavigate();

  // useEffect(() => {
  //   server
  //     .get("/register/studentprofile", {
  //       headers: {
  //         Authorization: student.authToken,
  //         "Content-Type": "application/json",
  //         Accept: "application/json",
  //       },
  //     })
  //     .then((response) => {
  //       updateDashboardState("Student", response.data);
  //     })
  //     .catch((error) => {
  //       if (error.response?.status === 401) {
  //         navigate("/loginstudent");
  //       }
  //       console.log(
  //         "error",
  //         error.message,
  //         error.response?.status,
  //         error.response?.data,
  //         error
  //       );
  //     });
  // }, []);
  return (
    <>
      <Header />
      <div className="row min-height-window">
        <div className="">
          {student ? (
            <Sidebar role="Student" />
          ) : (
            <Navigate to="/loginstudent" />
          )}
        </div>
        {/* <div className="col-md-10 py-2 ">
          <Outlet />
        </div> */}
      </div>
      <Footer />
    </>
  );
};

export default StudentContainer;
